import { useTranslation } from 'react-i18next'

import { EnrolState } from 'enum'
import Button from 'design-system/button'
import { ButtonSizes, ButtonVariant } from 'design-system/button/src/Button'
import { prefix } from '../constants'

interface ButtonsProps {
  note: string
  onSelect: (state: EnrolState) => void
}

export const Buttons = ({ note, onSelect }: ButtonsProps) => {
  const { t } = useTranslation()
  const MIN_NOTE = 10

  const disableDenied = note.length < MIN_NOTE

  return (
    <>
      <Button
        size={ButtonSizes.Small}
        variant={ButtonVariant.Danger}
        disabled={disableDenied}
        onClick={() => onSelect(EnrolState.Denied)}
      >
        {disableDenied
          ? t(`${prefix}.deniedDisabled`, {
              count: MIN_NOTE - note.length,
            })
          : t(`${prefix}.denied`)}
      </Button>
      <Button
        size={ButtonSizes.Small}
        variant={ButtonVariant.Primary}
        onClick={() => onSelect(EnrolState.Approved)}
      >
        {t(`${prefix}.approved`)}
      </Button>
    </>
  )
}
